<div class="col matrix">
  <!-- Dropdowns -->
  <div class="row padding all dropdowns" *ngIf="keyway">
    <div class="col padding">
      <div class="custom margin sm bottom">Key Section</div>
      <div class="data margin lrg top right bottom left">
        {{ keyway.name }}
      </div>

      <!-- Device Chamber -->
      <mat-form-field
        floatLabel="always"
        appearance="outline"
        class="fill margin top right"
        *ngIf="selectedMasterKey?.rck?.attribute?.lostBallChamber"
      >
        <div class="custom margin sm bottom">Device Chamber</div>

        <mat-select
          matNativeControl
          [(ngModel)]="selectedMasterKey.rck.attribute.lostBallChamber"
          (ngModelChange)="calcBitting(selectedMasterKey.rck.attribute.lostBallChamber)"
          required
          [disabled]="true"
        >
          <mat-option [value]="2" *ngIf="structure.combinatingRuleSetId === 1"> 2 </mat-option>
          <mat-option [value]="3"> 3 </mat-option>
          <mat-option [value]="4" *ngIf="structure.combinatingRuleSetId === 1"> 4 </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Deactivating Key -->
      <mat-form-field
        floatLabel="always"
        appearance="outline"
        class="margin right"
        *ngIf="selectedMasterKey?.rck?.attribute?.lostBallDeActivateKeyType"
      >
        <div class="custom margin sm bottom">Deactivating Key</div>

        <mat-select
          [disabled]="true"
          matNativeControl
          [(ngModel)]="selectedMasterKey.rck.attribute.lostBallDeActivateKeyType"
          required
        >
          <mat-option [value]="1"> Master </mat-option>
          <mat-option [value]="2"> Changes </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <app-kba-input-array [block]="[keyBitting]" [disabled]="true"> Bitting </app-kba-input-array>
</div>
